import createReducer, { mergeReducers } from "../../../lib/createReducer";
import { CHANGE_PASSWORD_REQUEST, CHANGE_PASSWORD_SUCCESS, CHANGE_PASSWORD_ERROR } from "./action";

const init = {
  isFetching: false,
  fetchSuccess: false,
  hasError: false,
  payload: null,
  error: null,
};

const requestReducer = createReducer(
  CHANGE_PASSWORD_REQUEST,
  () => ({
    ...init,
    isFetching: true,
  }),
  true
);

const successReducer = createReducer(CHANGE_PASSWORD_SUCCESS, ({ response }) => ({
  isFetching: false,
  fetchSuccess: true,
  payload: response,
}));

const errorReducer = createReducer(CHANGE_PASSWORD_ERROR, ({ error }) => ({
  isFetching: false,
  hasError: true,
  error,
}));

export default mergeReducers([requestReducer, successReducer, errorReducer], init);
